import {
  ADD_NEW_ROW,
  DELETE_ROW,
  EXAMSERIES_MONTH_HANDLECHANGE,
  EXAMSERIES_YEAR_HANDLECHANGE,
  EXAM_HANDLECHANGE,
  EXAMCENTER_HANDLECHANGE,
  CANDIDATENUMBER_HANDLECHANGE,
  UPDATE_EMPTY_FLAG_EXAM,
  UPDATE_DUPLICATE_FLAG_EXAM,
  INSTITUTE_HANDLE_CHANGE,
  UPDATE_EMPTY_FLAG_INSTITUTE,
  UPDATE_DUPLICATE_FLAG_INSTITUTE,
  ADD_NEW_ROW_INSTITUTE,
  DELETE_ROW_INSTITUTE,
  SET_CURRENT_USER_DATA,
  SET_NAMES_FROM_HISTORY,
  SET_SHOW_LOADER_STAUS,
  SET_CURRENT_USER_LOGGED_IN_STATUS,
  TOGGLE_ALERT,
  UPDATE_PERSONAL_INFO_FLAG,
  UPDATE_EXAM_DETAILS_FLAG,
  UPDATE_INSTITUTION_DETAILS_FLAG,
  UPDATE_EXAM_INSTITUTION_REVIEW_FLAG,
  UPDATE_INSTITUTION_REVIEW_FLAG,
  UPDATE_REVIEW_FLAG,
  SET_PERSONAL_INFO_DATA,
  RESET_PERSONAL_INFO_DATA,
  SAVE_PERSONAL_INFO_DATA,
  RESET_COMMON_DATA,
  SET_TRANSACTION_ID,
  SUBMIT_INFO,
  GET_EXAM_CENTRE_LIST,
  GET_EXAM_CENTRE_LIST_SUCCESS,
  GET_EXAM_CENTRE_LIST_ERROR,

  GET_INSTITUTION_LIST,
  GET_INSTITUTION_LIST_SUCCESS,
  GET_INSTITUTION_LIST_ERROR,
  GET_EXAM_SERIES,
  GET_EXAM_SERIES_SUCCESS,
  GET_EXAM_SERIES_ERROR,
  UPDATE_REVIEW_DETAILS_FLAG,
  SET_REQUEST_ID,
  SAVE_EXAM_DETAILS,
  SAVE_EXAM_DETAILS_SUCCESS,
  RESET_EXAM_DETAILS,
  SAVE_INSTITUTION_DETAILS,
  RESET_INSTITUTION_DETAILS,
  SET_TOTAL_TRANSCRIPT_AMOUNT,
  GET_TRANSRIPT_COSTS,
  SET_TRANSCRIPTS_COST_SUCCESS,
  SET_TRANSCRIPTS_COST_ERROR,
  UPDATE_PAY_FLAG,
  UPDATE_ADYEN_FLAG,
  HISTORY_PAY_NAV_FLAG,  
  SET_REVIEW_PAY_STATIC_SUCCESS,
  SET_REVIEW_PAY_STATIC_ERROR,
  SET_TRANSACTION_HISTORY_SUCCESS,
  SET_TRANSACTION_HISTORY_ERROR,
  GET_TRANSACTION_HISTORY,
  SET_TRANSACTION_SUMMARY_ERROR,
  SET_TRANSACTION_SUMMARY_SUCCESS,
  RESET_HISTORY_FLAGS,
  UPDATE_TRANSACTION_HISTORY_FLAG,
  RESET_REVIEW_DATA,
  RESET_STATE_TRANSITION_FLAGS,
  SET_DEVICE_TYPE,
  GET_TRANSACTION_SUMMARY,
  GET_TERMS_CONDITIONS,
  TERMS_CONDITIONS_ACCEPTED,
  GET_TERMS_CONDITIONS_SUCCESS
} from "./actionTypes";


export const addNewRow = () => ({
  type: ADD_NEW_ROW,
});

export const deleteRow = (id) => ({
  type: DELETE_ROW,
  id: id
});

export const examSeriesMonthHandleChange = (value,index) => ({
  type: EXAMSERIES_MONTH_HANDLECHANGE,
  payload : { value: value,
  index: index}
});

export const examSeriesYearHandleChange = (value,index) => ({
  type: EXAMSERIES_YEAR_HANDLECHANGE,
  payload : { value: value,
    index: index}
});

export const examHandleChange = (value,index) =>({
  type: EXAM_HANDLECHANGE,
  payload : { value: value,
    index: index}
});


export const examCenterHandleChange = (value,index) =>({
  type: EXAMCENTER_HANDLECHANGE,
  payload : { value: value,
    index: index}
});

export const candidateNumberHandleChange = (value,index) =>({
  type: CANDIDATENUMBER_HANDLECHANGE,
  payload : { value: value,
    index: index}
});

export const updateEmptyFlagExam = (value,index) =>({
  type: UPDATE_EMPTY_FLAG_EXAM,
  payload : { value: value,
    index: index}
});

export const updateDuplicateFlagExam = (value,index) =>({
  type: UPDATE_DUPLICATE_FLAG_EXAM,
  payload : { value: value,
    index: index}
});

export const instituteHandleChange = (value,index) =>({
  type: INSTITUTE_HANDLE_CHANGE,
  payload : { value: value,
    index: index}
});

export const updateEmptyFlagInstitute = (value,index) =>({
  type: UPDATE_EMPTY_FLAG_INSTITUTE,
  payload : { value: value,
    index: index}
});

export const updateDuplicateFlagInstitute = (value,index) =>({
  type: UPDATE_DUPLICATE_FLAG_INSTITUTE,
  payload : { value: value,
    index: index}
});

export const addNewRowInstitute = () => ({
  type: ADD_NEW_ROW_INSTITUTE,
  payload: {}
});

export const deleteRowInstitute = (id) => ({
  type: DELETE_ROW_INSTITUTE,
  id: id
});

export const setCurrentUserData = data => ({
  type: SET_CURRENT_USER_DATA,
  payload: {
    ...data
  }
});

export const setNamesFromHistoryAndModified = data =>({
  type: SET_NAMES_FROM_HISTORY,
  payload: {
    ...data
  }
})


export const setShowLoaderStatus = status => ({
  type: SET_SHOW_LOADER_STAUS,
  payload: {
    status
  }
});

export const setCurrentuserLoggedInStatus = status => ({
  type: SET_CURRENT_USER_LOGGED_IN_STATUS,
  payload: {
    status
  }
});

export const toggleAlertShowStatus = alertInfo => ({
  type: TOGGLE_ALERT,
  payload: {
    alertInfo
  }
});

  export const updatePersonalInfoFlag = () => ({
    type: UPDATE_PERSONAL_INFO_FLAG,
  });
  
  export const updateExamDetailsFlag = () => ({
    type: UPDATE_EXAM_DETAILS_FLAG,
  });

  export const updateInstitutionDetailsFlag = () => ({
    type: UPDATE_INSTITUTION_DETAILS_FLAG,
  });

  export const updatereviewDetailsFlag = () => ({
    type: UPDATE_REVIEW_DETAILS_FLAG ,
  });
  
  export const updateExamInstitutionReviewFlags = () => ({
    type: UPDATE_EXAM_INSTITUTION_REVIEW_FLAG,
  });

  export const updateInstitutionReviewFlags = () => ({
    type: UPDATE_INSTITUTION_REVIEW_FLAG,
  });

  export const updateReviewFlags = () => ({
    type: UPDATE_REVIEW_FLAG,
  });

  export const updatePayFlag = () => ({
    type: UPDATE_PAY_FLAG
  })

  export const updateAdyenFlag = () => ({
    type: UPDATE_ADYEN_FLAG
  })

  export const updateHistoryPayNavFlag = () => ({
    type: HISTORY_PAY_NAV_FLAG
  })

  export const setPersonalInfoData = data => ({
    type: SET_PERSONAL_INFO_DATA,
    payload: {
      ...data
    }
  });
  
  export const resetPersonalInfoData = () => ({
    type: RESET_PERSONAL_INFO_DATA
  });


  export const submitInfo = (data, callback) => ({
    type: SUBMIT_INFO,
    payload: {
      ...data, callback
    }
  });
  
  export const savePersonalInfo = (data, callback) => ({
    type: SAVE_PERSONAL_INFO_DATA,
    payload: {
      ...data, callback
    }
  });

  export const resetCommonDataData = () => ({
    type: RESET_COMMON_DATA
  });

  export const setTransactionId = (id) => ({
    type: SET_TRANSACTION_ID,
    payload: {
      id
    }
  });

  export const getExamCenters = () => ({
    type: GET_EXAM_CENTRE_LIST
  });

  export const getExamCentersSuccess = (centers) => ({
    type: GET_EXAM_CENTRE_LIST_SUCCESS,
    payload: {
      centers
    }
  });

  export const getExamCentersError = () => ({
    type:  GET_EXAM_CENTRE_LIST_ERROR
  });

  export const getInstitutions = () => ({
    type: GET_INSTITUTION_LIST
  });

  export const getInstitutionsSuccess = (institutions) => ({
    type: GET_INSTITUTION_LIST_SUCCESS,
    payload: {
      institutions
    }
  });

  export const getInstitutionsError = () => ({
    type:  GET_INSTITUTION_LIST_ERROR
  });
 

  export const getExamSeries = () => ({
    type: GET_EXAM_SERIES
  });

  export const getExamSeriesSuccess = (sessions) => ({
    type: GET_EXAM_SERIES_SUCCESS,
    payload: {
      sessions
    }
  });

  export const getExamSeriesError = () => ({
    type:  GET_EXAM_SERIES_ERROR
  });

  export const setRequestId = (data) =>({
  type: SET_REQUEST_ID,
  payload: {
    ...data
  }
});

  export const saveExamDetails = (data, callback) => ({
    type: SAVE_EXAM_DETAILS,
    payload: {
      ...data, callback
    }
  });

  export const saveExamDetailsSuccess = (res) => ({
    type: SAVE_EXAM_DETAILS_SUCCESS,
    payload: {
      ...res
    }
  });

  export const restExamDetails = () => ({
    type: RESET_EXAM_DETAILS
  });

  export const saveInstitutionDetails = (data, callback) => ({
    type: SAVE_INSTITUTION_DETAILS,
    payload: {
      ...data, callback
    }
  });

  export const restInstitutionDetails = () => ({
    type: RESET_INSTITUTION_DETAILS
  });

  export const setTotalTranscriptAmount = amount => ({
    type: SET_TOTAL_TRANSCRIPT_AMOUNT,
    payload: {
      amount
    }
  });

  export const resetReviewDetails = () => ({
    type: RESET_REVIEW_DATA
  });

  export const getTranscriptsCost = transactionId =>({    
      type: GET_TRANSRIPT_COSTS,
      payload:{
        transactionId
      }    
  });

  export const setTranscriptsSuccess = (costs) => ({
    type: SET_TRANSCRIPTS_COST_SUCCESS,
    payload: {
      costs
    } 
  });

  export const setTranscriptsError = () => ({
    type: SET_TRANSCRIPTS_COST_ERROR

  });  
  
  export const getReviewPaySuccess = (staticData) => ({
    type: SET_REVIEW_PAY_STATIC_SUCCESS,
    payload: {
      staticData
    }
  });

  export const getReviewPayError = () => ({
    type:  SET_REVIEW_PAY_STATIC_ERROR
  });

  export const setTransactionHistorySuccess = tHistory => ({
    type: SET_TRANSACTION_HISTORY_SUCCESS,
    payload: {
      tHistory
    } 
  });

  export const setTransactionHistoryError = () => ({
    type: SET_TRANSACTION_HISTORY_ERROR    
  });

  export const updateTranscriptHistoryFlag = () => ({
    type: UPDATE_TRANSACTION_HISTORY_FLAG    
  });

  export const resetStateTransitionFlags = () =>({
    type: RESET_STATE_TRANSITION_FLAGS
  })

  export const setDeviceType = device => ({
    type: SET_DEVICE_TYPE,
    payload:{
      device
    }
  })

  export const getTranscriptHistory = tReq =>({
    type: GET_TRANSACTION_HISTORY,
    payload:{
      tReq
    }
  })
  export const getTranscriptSummary = tReq =>({
    type: GET_TRANSACTION_SUMMARY,
    payload:{tReq}
  })
  export const setTransacriptSummarySuccess = tSummary => ({
    type: SET_TRANSACTION_SUMMARY_SUCCESS,
    payload: {tSummary} 
  });

  export const setTransciptSummaryError = () => ({
    type: SET_TRANSACTION_SUMMARY_ERROR    
  });

  export const resetHistoryFlags = () => ({
    type: RESET_HISTORY_FLAGS    
  });

  export const acceptedTermsAndConditions = tReq =>({
    type: TERMS_CONDITIONS_ACCEPTED,tReq
  })
  
  export const getTermsAndConditions = tId =>({
    type: GET_TERMS_CONDITIONS,payload:{tId}
  })

  export const getTermsAndConditionsSuccess = (tAndC) =>({
    type: GET_TERMS_CONDITIONS_SUCCESS,
    payload:{tAndC}
  })